import React, { useState, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";
import useStaffSubmit from "hooks/useStaffSubmit";
import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";
import InputArea from "components/form/InputArea";
import InputValue from "components/form/InputValue";
import Error from "components/form/Error";
import SelectRole from "components/form/SelectRole";
import DrawerButton from "components/form/DrawerButton";
import SelectState from "components/form/SelectStaffState";
import SelectCity from "components/form/SelectCity";
import SelectAllCityState from "components/form/SelectAllCityState";
import InputMobileWoCode from "components/form/InputMobileWoCode";
import SelectRegionalHead from "components/form/SelectRegionalHead";

const StaffDrawer = ({ id }) => {
  const [SelectedAllState] = useState("");
  const [selectedRole, setSelectedRoleId] = useState(null); //  store role id
  const [selectedRoleName, setSelectedRoleName] = useState(""); //  store role name
  const [showRegionalHead, setShowRegionalHead] = useState(false);
  const handleRoleChange = (e) => {
    const roleId = Number(e.target.value); // always store number
    const roleName = e.target.options[e.target.selectedIndex].text.toLowerCase();

    setSelectedRoleId(roleId);
    setSelectedRoleName(roleName);

    // show Regional Head only for Sale/Sales
    if (roleName === "sale" || roleName === "sales" || roleName === "transport manager" || roleName === "transport manager") {
      setShowRegionalHead(true);
    } else {
      setShowRegionalHead(false);
      setValue("regional_head_id", "");
    }
  };
  // Your existing useEffect for profileName

  const {
    trigger,
    register,
    handleSubmit,
    selectedState,
    setSelectedState,
    selectedCities,
    setSelectedCities,
    onSubmit,
    loading,
    errors,
    selectedAllCityinState,
    setSelectedAllCityinState,
    selectedRoleId,

    profileName
    , watch, setValue, existingid,
  } = useStaffSubmit(id);

  useEffect(() => {
    if (!profileName) {
      setShowRegionalHead(false);
      setValue("regional_head_id", "");
      return;
    }

    const lowerName = profileName.toLowerCase();
    if (lowerName === "sale" || lowerName === "sales" || lowerName === "transport manager" || lowerName === "transport manager") {
      setShowRegionalHead(true);
    } else {
      setShowRegionalHead(false);
      setValue("regional_head_id", "");
    }
  }, [profileName, setValue]);


  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit Employee" />
        ) : (
          <Title register={register} title="Add Employee" />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card
          className="flex-grow scrollbar-hide w-full max-h-full"
          style={{ overflow: "visible" }}
        >
          <CardBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div
                  className="grid grid-cols-12 gap-y-6 gap-x-5 mb-6 items-center"
                  style={{ gridAutoRows: "auto" }}
                >
                  <div className="col-span-6">
                    <LabelArea required label="First Name" />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="First Name"
                      name="firstname"
                      type="text"
                      placeholder="Jhon"
                      pattern={/^[a-zA-Z0-9]+$/}

                    />
                    <Error errorName={errors.firstname} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Last Name" />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Last Name"
                      name="lastname"
                      type="text"
                      placeholder="s"
                      pattern={/^[a-zA-Z0-9]+$/}

                    />
                    <Error errorName={errors.lastname} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Email" />
                    <InputValue
                      trigger={trigger}
                      register={register}
                      label="Email"
                      name="email"
                      type="text"
                      pattern={/^[A-Za-z0-9][A-Za-z0-9._-]*@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/}

                      placeholder="jhon@gmail.com"
                    />
                    <Error errorName={errors.email} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Password" />
                    <InputArea
                      trigger={trigger}
                      register={register}
                      label="Password"
                      name="password_update"
                      type="text"
                      placeholder="Atleast 1 uppercase, low1ercase, number & special char"
                      pattern={/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{6,}$/}
                    />

                    <Error errorName={errors.password_update} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea required label="Contact Number" />
                    <InputMobileWoCode
                      trigger={trigger}
                      register={register}
                      maxLength={10}
                      minLength={10}
                      label="Contact Number"
                      name="mobile"
                      type="number"
                      placeholder="8345378678"
                      pattern={/^\d{10}$/}
                    />
                    <Error errorName={errors.mobile} />
                  </div>

                  {/*  Employee Role Dropdown */}
                  <div className="col-span-6">
                    <LabelArea required label="Employee Role" />
                    <SelectRole
                      register={register}
                      label="Employee Role"
                      name="id_profile"
                      onChange={handleRoleChange} //  track change
                    />
                    <Error errorName={errors.id_profile} />
                  </div>

                  {/*  Conditionally show Regional Head dropdown */}
                  {showRegionalHead && (
                    <div className="col-span-6">
                      <LabelArea required label="Select Regional Head" />
                      <SelectRegionalHead
                        register={register}
                        name="regional_head_id"
                        label="Regional Head"
                        selectedRoleId={selectedRole || selectedRoleId} // always current role
                        selectedRegionalHeadId={watch("regional_head_id") || existingid} // existing or form value
                        setValue={setValue}
                      />


                      <Error errorName={errors.regional_head_id} />
                    </div>
                  )}





                  <div className="col-span-6">
                    <LabelArea required label="Select State" />
                    <SelectState
                      onSelectState={setSelectedState}
                      register={register}
                      name="state"
                      required={false}
                      selectedServiceState={selectedState}
                      setSelectedServiceState={setSelectedState}
                    />

                    <Error errorName={errors.state} />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Select All city in State" />
                    <SelectAllCityState
                      onSelectState={setSelectedAllCityinState}
                      register={register}
                      name="allcityinstate"
                      selectOptions={selectedState}
                      selectedServiceState={selectedAllCityinState}
                      setSelectedServiceState={setSelectedAllCityinState}
                    />
                  </div>

                  <div className="col-span-6">
                    <LabelArea label="Select City" />
                    <SelectCity
                      register={register}
                      name="city"
                      selectedStates={selectedState}
                      selectedAllCityinState={selectedAllCityinState}
                      selectedCities={selectedCities}
                      setSelectedCities={setSelectedCities}
                      onSelectedAllStates={SelectedAllState}
                    />

                    <Error errorName={errors.city} />
                  </div>
                </div>
              </div>

              <DrawerButton id={id} isSubmitting={loading} />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default StaffDrawer;
